/**
 * Return date range options until the end date
 * @param {Date} end - Until this date
 * keywords: dateRangeOptions
 */
import { sub } from 'date-fns';

import type { OptionOf } from '~/components/molecule/Dropdown';
import type { GetEmailEffectivenessGroupedByFlowV2BlueprintQueryVariables } from '~/graphql/types';

const getDateRangeOptionsWithEndDate = (
  end: Date,
): Array<
  OptionOf<{
    start: GetEmailEffectivenessGroupedByFlowV2BlueprintQueryVariables['start'];
    end: GetEmailEffectivenessGroupedByFlowV2BlueprintQueryVariables['end'];
  }>
> => [
  {
    key: 'last-90-days',
    label: 'Afgelopen 90 dagen',
    payload: {
      end: end.toISOString(),
      start: sub(end, { days: 90 }).toISOString(),
    },
  },
  {
    key: 'last-two-week',
    label: 'Afgelopen 14 dagen',
    payload: {
      end: end.toISOString(),
      start: sub(end, { days: 14 }).toISOString(),
    },
  },
  {
    key: 'last-week',
    label: 'Afgelopen week',
    payload: {
      end: end.toISOString(),
      start: sub(end, { weeks: 1 }).toISOString(),
    },
  },
];
export default getDateRangeOptionsWithEndDate;
